import React from "react";
import styles from "./index.module.scss";
import InvestorActivitySkeleton from "../../../skeleton/investor-activity-skeleton";
import { dateAndTimeFormat, pstDateFormat } from "../../../utils/utils";
import { useSearchParams } from "react-router-dom";

function ActivityMessage(
  date: string,
  eventType: string,
  sec?: number,
  city: string = "",
  street: string = "",
  imagesCount: number = 0,
  openCount: string = ""
) {
  
  const minutes = ((sec || 0) / 60).toFixed(2);
  switch (eventType) {
    case "Get Realist Report Document Viewed":
      return `Viewed Realist Report for ${street}, ${city}`;
    case "Login with OTP Button Clicked":
      return `Logged in with OTP at ${dateAndTimeFormat(date)}`;
    case "Logout Clicked":
      return `Logged out at ${dateAndTimeFormat(date)}`;
    case "Property Detail Image Clicked":
      return `Opened property Images`;
    case "Property Details Viewed":
      return `Viewed ${street} 5 times today`;
    case "Resend OTP Clicked":
      return `Requested resend OTP`;
    case "Verify Button Clicked":
      return `Verify Button Clicked`;
    case "View Comparables Document Viewed":
      return `Viewed Comparables report for ${street}, ${city}`;
    case "Total Time Spent":
      return `Spent ${minutes} minutes viewing ${street}, ${city}`;
    case "[Amplitude] Start Session":
      return `Session Stared at ${dateAndTimeFormat(date)}`;
    case "[Amplitude] End Session":
      return `Session ended at ${dateAndTimeFormat(date)}`;
    case "View More Clicked":
      return `Clicked view more to expand content`;
    case "See All Features Clicked":
      return `Expanded to view all property features`;
    case "See Less Features Clicked":
      return `Collapses property features list`;
    case "Total Full Screen Image Viewed":
      return `Viewed images in full screen mode`;
    case "Email":
      return `Investor opened email about ${street}, ${city} ${openCount} times today`;
    case "Total Property Image Viewed":
      return `Viewed ${imagesCount} images for ${street}, ${city}`;
  }
}

export default function ActivitySection({
  data,
  isLoading,
  observerTarget,
  isFetchingNextPage
}: {
  data: any;
  isLoading: boolean;
  observerTarget: any;
  isFetchingNextPage: boolean;
}) {
  const [searchParams] = useSearchParams();
  const city = searchParams.get("city") || "";
  const street = searchParams.get("street") || "";
  return (
    <div className={styles.activitySection}>
      <div className={styles.headerTitle}>Investor Activity</div>
      <div className={styles.contentWrap}>
        {!isLoading ? (
          <>
            {data?.pages?.[0].activities?.length > 0 ? (
              data?.pages?.map((page: any) => {
                return page?.activities?.map((item: any) => (
                  <div className={styles.content} key={item.eventType}>
                    <span className={styles.title}>
                      {ActivityMessage(
                        item.maxEventDate,
                        item.eventType,
                        item.totalTimeSpentOnPage,
                        city,
                        street,
                        item.totalNumberOfImagesViewed,
                        item.openCount
                      )}
                    </span>
                    <div className={styles.date}>
                      {pstDateFormat(item.maxEventDate)}
                    </div>
                  </div>
                ));
              })
            ) : (
              <div className={styles.noDataFound}>No activity found</div>
            )}
            <div ref={observerTarget} style={{ height: "20px", width: "100%" }}>
              {isFetchingNextPage && (
                <div className={styles.loadingMore}>Loading more...</div>
              )}
            </div>
          </>
        ) : (
          Array.from({ length: 10 }).map((_, index) => (
            <InvestorActivitySkeleton key={index} />
          ))
        )}
      </div>
    </div>
  );
}
